import { Delete, Edit } from "@mui/icons-material";
import { Autocomplete, Button, IconButton, TextField } from "@mui/material";
import { USER_TYPE_OPTIONS } from "utils/userMembershipUtils";

export default function MembershipRowsEditor({
  rows,
  orgOptions,
  availableOrgs,
  onAddOrg,
  onRemoveRow,
  onRoleChange,
  onOpenPermissions,
}) {
  return (
    <div className="col-span-2 space-y-4">
      <div className="flex items-center justify-between">
        <label className="block uppercase text-app-text-secondary text-xs font-bold">
          Organisation memberships
        </label>
        <div className="flex items-center gap-2 min-w-[280px]">
          <Autocomplete
            disablePortal
            size="small"
            className="flex-1"
            options={availableOrgs}
            value={null}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_event, value) => {
              if (value) {
                onAddOrg(value);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Add organisation" placeholder="Select to add" />
            )}
          />
        </div>
      </div>

      {rows.length === 0 ? (
        <p className="text-sm text-app-text-secondary">
          Add at least one organisation membership with a role and permissions.
        </p>
      ) : (
        <div className="space-y-3">
          {rows.map((row) => (
            <div
              key={row.orgId}
              className="grid grid-cols-[1fr_minmax(180px,220px)_auto_auto] gap-3 items-center border border-app-border rounded-md p-3"
            >
              <div>
                <p className="font-medium text-app-text">{row.orgName}</p>
                <p className="text-xs text-app-text-muted">Org ID: {row.orgId}</p>
              </div>
              <Autocomplete
                disablePortal
                size="small"
                options={USER_TYPE_OPTIONS}
                value={USER_TYPE_OPTIONS.find((item) => item.value === row.role) || null}
                renderInput={(params) => <TextField {...params} label="User Type" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(_event, value) => onRoleChange(row.orgId, value?.value || "USER")}
              />
              <Button
                variant="outlined"
                size="small"
                startIcon={<Edit />}
                onClick={() => onOpenPermissions(row)}
              >
                Permissions
              </Button>
              <IconButton
                aria-label={`Remove ${row.orgName}`}
                onClick={() => onRemoveRow(row.orgId)}
                size="small"
              >
                <Delete fontSize="small" />
              </IconButton>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
